import * as ActionTypes from '../ActionTypes';

const initialState = {
    success_message: "",
    error: false,
    paygrade_options: []
};

const PaygradeReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.PAYGRADE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
                paygrade_options: []
            };
        case ActionTypes.PAYGRADE_GET_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                error: action.payload.has_error,
                paygrade_options: action.payload?.data?.data
            };
        case ActionTypes.PAYGRADE_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYGRADE_ADD_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                error: action.payload.has_error,
                paygrade_options: action.payload?.data?.data
            };
        case ActionTypes.PAYGRADE_ADD_ERROR:
            return {
                ...state,
                error: action.payload.has_error,
                isLoading: false,
            };
        case ActionTypes.PAYGRADE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYGRADE_UPDATE_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                error: action.payload.has_error,
                paygrade_options: action.payload?.data?.data
            };
        case ActionTypes.PAYGRADE_UPDATE_ERROR:
            return {
                ...state,
                error: action.payload.has_error,
                isLoading: false,
            };
        case ActionTypes.PAYGRADE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYGRADE_DELETE_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                error: action.payload.has_error,
                paygrade_options: action.payload?.data?.data
            };
        case ActionTypes.PAYGRADE_DELETE_ERROR:
            return {
                ...state,
                error: action.payload.has_error,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default PaygradeReducer;